import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createWithdrawal = {
  name: "createWithdrawal" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({ withdrawalId: z.string() }),
};
